export default "__VITE_ASSET__Bu8FSdaf__"